module.exports = __webpack_public_path__ + "static/media/noun_outward.b0e2f439.svg";